export default async (selector) => {
  const tables = document.querySelectorAll(selector);

  if (tables.length === 0) {
    return;
  }

  const { default: tablesort } = await import('tablesort');

  tables.forEach((table) => {
    tablesort(table);
  });
};
